export default "__VITE_ASSET__DHPL8tfG__"